import React from 'react';

import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { Controller } from "react-hook-form";


interface IProps {
  name: string
  error?: any
  label?: string
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | 'default'
  control: any
  isRequired?: boolean
  disabled?: boolean
  disableRipple?: boolean
  icon?: React.ReactNode
  checkedIcon?: React.ReactNode
}

const CheckboxField = React.forwardRef<HTMLInputElement, IProps>((props: IProps, ref) => {
  const {
    name,
    error,
    label,
    color, // The color of the component. It supports both default and custom theme colors, which can be added as shown in the palette customization guide
    control,
    disabled,  // If true, the component is disabled
    isRequired, // If true, the input element is required
    icon, // The icon to display when the component is unchecked
    checkedIcon, // The icon to display when the component is checked 
    disableRipple // If true, the ripple effect is disabled
  } = props;

  return (
    <FormControl fullWidth error={error}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <FormGroup>
            <FormControlLabel control={
              <Checkbox
                {...field}
                disabled={disabled}
                checkedIcon={checkedIcon}
                disableRipple={disableRipple}
                color={color}
                icon={icon}
                checked={field.value || false}
                required={isRequired}
                inputRef={ref}
                
                inputProps={{
                  // @ts-ignore
                  'data-testid': field.name
                }}
              />}
              label={label}
            />
            {error ? (
              <FormHelperText>{error.message}</FormHelperText>
            ) : null}

          </FormGroup>
        )}
      />
    </FormControl>
  );
});

CheckboxField.defaultProps = {
  isRequired: false,
  disabled: false,
  disableRipple: false,
};

export { CheckboxField };
